'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, ClickAwayListener } from '@mui/material';
import type React from 'react';
import { useRef, useState } from 'react';
import { NwTooltip } from './NwTooltip';
export interface HoverTooltipProps extends React.ComponentProps<typeof NwTooltip> {
  position?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: string | number;
  title: React.ReactNode;
  renderStatic?: boolean;
  children: React.ReactElement;
}
export const HoverTooltip = t0 => {
  const $ = _c(39);
  let children;
  let props;
  let t1;
  let t2;
  let t3;
  let title;
  if ($[0] !== t0) {
    ({
      position: t1,
      title,
      children,
      maxWidth: t2,
      renderStatic: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = title;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    title = $[6];
  }
  const position = t1 === undefined ? "top" : t1;
  const maxWidth = t2 === undefined ? 240 : t2;
  const renderStatic = t3 === undefined ? false : t3;
  const [isHoveringChildren, setIsHoveringChildren] = useState(false);
  const [isHoveringTitle, setIsHoveringTitle] = useState(false);
  const popperRef = useRef(null);
  const isVisible = isHoveringTitle || isHoveringChildren;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maxWidth: "fit-content"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isVisible) {
    t5 = e => {
      if (isVisible && !popperRef.current?.contains(e.target as Node)) {
        setIsHoveringChildren(false);
        setIsHoveringTitle(false);
      }
    };
    $[8] = isVisible;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      border: "1px solid",
      borderColor: "grey.100",
      borderRadius: "20px"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = renderStatic && !isVisible ? "none" : "block";
  const t8 = renderStatic ? maxWidth : "auto";
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = {
      display: t7,
      width: t8
    };
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  let t11;
  if ($[14] !== isHoveringTitle) {
    t10 = () => {
      if (!isHoveringTitle) {
        setIsHoveringTitle(true);
      }
    };
    t11 = () => {
      if (isHoveringTitle) {
        setIsHoveringTitle(false);
      }
    };
    $[14] = isHoveringTitle;
    $[15] = t10;
    $[16] = t11;
  } else {
    t10 = $[15];
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [{
      name: "preventOverflow",
      options: {
        boundary: "viewport",
        padding: 3
      }
    }];
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== renderStatic || $[19] !== t10 || $[20] !== t11 || $[21] !== t9) {
    t13 = {
      ref: popperRef,
      disablePortal: renderStatic,
      sx: t9,
      onMouseEnter: t10,
      onMouseLeave: t11,
      modifiers: t12
    };
    $[18] = renderStatic;
    $[19] = t10;
    $[20] = t11;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = renderStatic ? true : isVisible;
  let t15;
  let t16;
  if ($[23] !== isHoveringChildren) {
    t15 = () => {
      if (!isHoveringChildren) {
        setIsHoveringChildren(true);
      }
    };
    t16 = () => {
      if (isHoveringChildren) {
        setIsHoveringChildren(false);
      }
    };
    $[23] = isHoveringChildren;
    $[24] = t15;
    $[25] = t16;
  } else {
    t15 = $[24];
    t16 = $[25];
  }
  let t17;
  if ($[26] !== children || $[27] !== maxWidth || $[28] !== position || $[29] !== props || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t16 || $[34] !== title) {
    t17 = <NwTooltip {...props} sx={t6} PopperProps={t13} title={title} placement={position} arrow={true} open={t14} maxWidth={maxWidth} onMouseEnter={t15} onMouseLeave={t16}>{children}</NwTooltip>;
    $[26] = children;
    $[27] = maxWidth;
    $[28] = position;
    $[29] = props;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = title;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17 || $[37] !== t5) {
    t18 = <Box data-testid="hover-tooltip" sx={t4}><ClickAwayListener onClickAway={t5}>{t17}</ClickAwayListener></Box>;
    $[36] = t17;
    $[37] = t5;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};